import React from "react";
import { FaGooglePlay } from "react-icons/fa";
import "./Buttons.css";
import { useTranslation } from "react-i18next";
const DownloadOnGooglePlayMobile = () => {
  const { t } = useTranslation();
  return (
    <>
      <a href="##" className="mobile-button-link">
        <div className="mobile-button-flex">
          <div className="download-icon-mobile">
            <FaGooglePlay className="icon-play-store" />
          </div>
          <div className="download-text-mobile">
            <p>
              {t("Download")} {t("on")}{" "}
            </p>
            <h5>Play Store</h5>
          </div>
        </div>
      </a>
    </>
  );
};

export default DownloadOnGooglePlayMobile;
